import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { LoaderService } from './loader.service';
import { finalize } from 'rxjs/operators';
import { NguAlertService } from '@app/shared';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  messenger: any;
  isOffline;
  constructor(private load: LoaderService, private alert: NguAlertService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // console.log('loader');
    // console.count('api calls');
    const isOnline = navigator.onLine;
    if (!isOnline) {
      if (!this.isOffline) {
        this.alert.open({
          heading: 'Your are Offline',
          msg: `Check Your internet connection`,
          type: 'danger',
          duration: 10000
        });
      }
      this.isOffline = true;
      return;
    }
    this.isOffline = false;

    this.load.show();
    // send cloned request with header to the next handler.
    return next.handle(req).pipe(
      finalize(() => {
        this.load.hide();
      })
    );
  }
}
